/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Tab_CoinsInputs */

const en_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

const ar_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العملة`)
};

const de_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung`)
};

const es_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moneda`)
};

const fr_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monnaie`)
};

const it_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

const ja_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通貨`)
};

const ko_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재화`)
};

const pt_br_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moeda`)
};

const ru_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валюта`)
};

const th_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สกุลเงิน`)
};

const tr_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para birimi`)
};

const zh_cn_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`货币`)
};

const zh_tw_store_tab_coins = /** @type {(inputs: Store_Tab_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貨幣`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Store_Tab_CoinsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const store_tab_coins = /** @type {((inputs?: Store_Tab_CoinsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Tab_CoinsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_store_tab_coins(inputs)
	if (locale === "ar") return ar_store_tab_coins(inputs)
	if (locale === "de") return de_store_tab_coins(inputs)
	if (locale === "es") return es_store_tab_coins(inputs)
	if (locale === "fr") return fr_store_tab_coins(inputs)
	if (locale === "it") return it_store_tab_coins(inputs)
	if (locale === "ja") return ja_store_tab_coins(inputs)
	if (locale === "ko") return ko_store_tab_coins(inputs)
	if (locale === "pt_br") return pt_br_store_tab_coins(inputs)
	if (locale === "ru") return ru_store_tab_coins(inputs)
	if (locale === "th") return th_store_tab_coins(inputs)
	if (locale === "tr") return tr_store_tab_coins(inputs)
	if (locale === "zh_cn") return zh_cn_store_tab_coins(inputs)
	return zh_tw_store_tab_coins(inputs)
});